var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTripsIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.433 11.55L12 18L16.65 11.445C17.524 10.353 18 8.996 18 7.598C18.02 4.26 15.338 1.533 12 1.5C9.64 1.535 7.51 2.928 6.533 5.078C5.556 7.228 5.906 9.748 7.433 11.55ZM7.5 7.598C7.475 5.086 9.489 3.029 12 3C14.511 3.027 16.525 5.085 16.5 7.598C16.495 8.653 16.133 9.676 15.473 10.5L12 15.39L8.617 10.598C7.901 9.762 7.505 8.698 7.5 7.598ZM12 8.25C12.828 8.25 13.5 7.578 13.5 6.75C13.5 5.922 12.828 5.25 12 5.25C11.172 5.25 10.5 5.922 10.5 6.75C10.5 7.578 11.172 8.25 12 8.25ZM21.75 18.72C21.75 17.0013 19.4179 15.8036 15.9235 15.2589L15.6925 16.7411L15.9773 16.7877C18.6012 17.238 20.25 18.106 20.25 18.72C20.25 19.0921 19.5252 19.6632 18.1265 20.1295C16.5314 20.6613 14.3428 20.97 12 20.97C9.65717 20.97 7.46859 20.6613 5.87345 20.1295C4.47477 19.6632 3.75 19.0921 3.75 18.72C3.75 18.0841 5.51867 17.1757 8.3075 16.7411L8.0765 15.2589L7.77122 15.3087C4.44691 15.8745 2.25 17.0519 2.25 18.72C2.25 20.4173 4.64216 21.6561 8.06682 22.1855L8.63101 22.2651C8.82194 22.2896 9.01568 22.3119 9.212 22.3321L9.80853 22.3861C9.90917 22.394 10.0104 22.4013 10.1122 22.4082L10.7296 22.4424C11.1454 22.4607 11.5695 22.47 12 22.47C12.4305 22.47 12.8546 22.4607 13.2704 22.4424L13.8878 22.4082C13.9896 22.4013 14.0908 22.394 14.1915 22.3861L14.788 22.3321C14.9843 22.3119 15.1781 22.2896 15.369 22.2651L15.9332 22.1855C19.3578 21.6561 21.75 20.4173 21.75 18.72Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTripsIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/trips_icon.3139ed21a77bb621e6fedf9ea1d72027.svg";